import {Component, Input, Output, EventEmitter, Inject} from '@angular/core';
import {Router } from '@angular/router';
import * as RouteStackAction from '../../../app/store/actions/route-stack.action';
import {Store} from '@ngrx/store';
import {AppState} from '../../../app/app.state';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-horizontal-menu-item',
  templateUrl: './horizontal-menu-item.component.html',
  styleUrls: ['./horizontal-menu-item.component.scss']
})
export class HorizontalMenuItemComponent {

  @Input() title = '';
  @Input() imgSrc = '';
  @Input() navigateTo = '';
  @Input() lastItem = false;
  @Input() disable = false;
  @Input() socialMedia = false;
  @Input() showBadge = false;
  @Input() appVersion = '';
  @Input() newTab = false;

  @Output() notifyParent: EventEmitter<any> = new EventEmitter();
  constructor(private router: Router,
              private store: Store<{ routeStack: AppState }>,
              @Inject(DOCUMENT) private document: Document) {
    this.store.dispatch(new RouteStackAction.ChangeWaitingPaymentStatus(false));
  }
  doAction() {
    if (this.disable) {
      this.notifyParent.emit('');
    } else {
      if (this.newTab) {
       window.open(this.navigateTo);
      } else if (this.socialMedia === true) {
        this.document.location.href = this.navigateTo;
      } else if (this.title === 'پشتیبانی آنلاین') {
        return;
      } else {
        this.router.navigate([this.navigateTo]);
        // [routerLink]="[navigateTo]"
      }
    }
  }
}
